import { RouteRecordRaw } from 'vue-router';

import { ROUTE_NAMES } from '@/constants';
import ShareLeafLink from '@/pages/ShareLeafLink/ShareLeafLink.vue';
import { toNonVueRoute } from '@/router/utils';

import i18n, { loadTranslations } from '../plugins/i18n';
import { authenticationGuard, fetchCommonData } from './guards';

const NotificationPreferences = () => import('@/pages/User/Preferences/NotificationPreferences.vue');

async function fetchTranslations() {
  await loadTranslations('user');
}

const notificationPreferencesRoutes: RouteRecordRaw[] = [
  // Legacy Routes
  toNonVueRoute({ path: '/user/profile/edit/', name: ROUTE_NAMES.PROFILE_EDIT }),

  // Vue
  {
    path: '/user/preferences/notifications',
    name: ROUTE_NAMES.NOTIFICATION_PREFERENCES,
    beforeEnter: [authenticationGuard, fetchCommonData, fetchTranslations],
    component: NotificationPreferences,
    meta: {
      title: () => i18n.t('user.notificationPreferences.title'),
      description: () => i18n.t('user.notificationPreferences.description'),
      permissions: [
        { rules: ['ogk_pod__knock_notifications', ({ userActiveCompany }) => Boolean(userActiveCompany?.staffId)] },
      ],
    },
  },
];

const userActionRoutes: RouteRecordRaw[] = [
  // Legacy Routes
  toNonVueRoute({ path: '/c/:company/reports/referrals', name: ROUTE_NAMES.REFERRALS_REPORT }),
  toNonVueRoute({ path: '/shareable-links', name: ROUTE_NAMES.SHAREABLE_LINKS }),

  {
    path: '/share-leaflink',
    name: ROUTE_NAMES.SHARE_LEAFLINK,
    beforeEnter: [authenticationGuard, fetchCommonData, fetchTranslations],
    component: ShareLeafLink,
    meta: {
      permissions: [{ rules: [({ userActiveCompany }) => Boolean(userActiveCompany?.seller)] }],
    },
  },
];

export default [...notificationPreferencesRoutes, ...userActionRoutes];
